export default "__VITE_ASSET__350b6732__"